// Define how many records are shown per page on the app level
export const PER_PAGE = 10;
